// Shared by the thread bubble and the list preview so both read a message's
// sanitized HTML the same way.

/** Dropped with their content; any other unknown tag still renders its text. */
export const DROPPED_TAGS = new Set([
  'script',
  'style',
  'noscript',
  'iframe',
  'object',
  'svg',
  'math',
]);

/** Tags that end a line of text. */
export const BLOCK_TAGS = new Set(['p', 'ul', 'ol', 'li', 'blockquote', 'pre']);

/** The parsed message body, or null where no DOMParser exists (server render). */
export function parseMessageHtml(html: string): HTMLElement | null {
  if (typeof DOMParser === 'undefined') return null;
  return new DOMParser().parseFromString(html, 'text/html').body;
}
